var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 py-1 rounded activeLabel d-flex align-center justify-center"},[_c('span',{staticClass:"text-uppercase font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('active'))+" ")]),_c('span',{staticClass:"dot ml-2"})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }